import { classInstance } from '@/shared/helpers/helpers';
import { NotifyElement } from '@/shared/notify/notify-element/notify-element';

import { getProductNotifyContent, type ProductNotifyOptions } from '../product-notify-content';

export class ProductNotifyElement extends NotifyElement {
	constructor(container: HTMLElement, options: ProductNotifyOptions) {
		super(container, {
			id: options.id,
			delay: options.delay ?? 0,
			type: `product-notify product-notify--${options.type}`,
			content: getProductNotifyContent(options),
		});
	}

	public override init(): void {
		classInstance.set(this.$element, { productNotify: this, notify: this });
		this.createShell();
	}

	public override destroy(): void {
		classInstance.del(this.$element, 'productNotify');
		classInstance.del(this.$element, 'notify');
		this.$element.remove();
	}

	private createShell(): void {
		const progress = document.createElement('div');
		progress.className = 'notify__progress';

		const handle = document.createElement('div');
		handle.className = 'notify__handle';

		progress.append(handle);
		this.$handle = handle;

		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'notify__close';
		button.innerHTML = '<i class="icon icon-close"></i>';

		const content = document.createElement('div');
		content.className = 'notify__content';
		content.innerHTML = this.content;

		button.addEventListener('click', () => this.close());

		this.$element.append(progress);
		this.$element.append(button);
		this.$element.append(content);
	}
}
